/* eslint-disable react/no-danger */
import React from 'react';
import { TextArea, Button, Alert } from 'common/components';
import type { Data } from '../../Expand';
import './Policy.scss';

const Policy: React.FC<{ policy: Data[] }> = ({ policy }) => {
  const { set } = Alert.Context();
  return (
    <div id="term-policy">
      {policy.map((el) => {
        return (
          <React.Fragment key={el.title}>
            <div className="term-content">
              <div className="term-title">약관 내용</div>
              <div className="inner-html" dangerouslySetInnerHTML={{ __html: el.content }} />
            </div>
            <div className="term-content">
              <div className="term-title">
                약관 HTML
                <Button
                  text="HTML 복사하기"
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(el.content);
                      set({ success: 'HTML 복사가 완료되었습니다.' });
                    } catch {
                      set({ fail: 'HTML 복사는 실패되었습니다.' });
                    }
                  }}
                />
              </div>
              <TextArea readonly className="html-textarea" value={el.content} styles={{ width: '100%', height: 136 }} />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Policy;
